import React, { useState, useEffect, useMemo } from 'react';
import ReactTelInput from 'react-telephone-input';
import { SpinnerV, SnackBar } from 'components/widgets';
import TextInput from 'components/commons/TextInput';
import Flags from '../../assets/images/flags.png';
import TagManager from 'react-gtm-module';
import { useRouter } from 'next/router';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from 'store/actions';

import Common from '../../services/common';
import {
	loadRecaptchaV3,
	getTokenReacaptcha
} from 'components/utils/recaptchaV3';

const Form = ({ actions }) => {
	const router = useRouter();
	const [formErrors, setFormErrors] = useState({});
	const [contact, setContact] = useState(defaultValues());
	const [openAlert, setOpenAlert] = useState(false);
	const [messageAlert, setMessageAlert] = useState('');
	const [showLoadding, setShowLoadding] = useState(false);
	const handleClose = () => setOpenAlert(false);

	// loader recaptcha

	useEffect(() => {
		loadRecaptchaV3();
	}, [router]);

	useEffect(() => {
		const requestLocation = () => {
			getLocation();
		};

		requestLocation();
	}, []);

	const getLocation = async () => {
		const response = await actions.getLocation();
		if (response) {
			setContact({
				...contact,
				country: response?.country,
				ip: response?.ip,
				ip_data: response?.ip_data,
				origin: 'Organic'
			});
		}
	};

	async function handleInput(event) {
		const { name, value } = event.target;
		setContact({ ...contact, [name]: value });

		await validateField(name, value);
	}

	const validateField = (field, value) => {
		let form = formErrors;
		let validate = false;
		switch (field) {
			case 'email':
				validate = /^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i.test(value);
				!validate ? (form.email = 'Correo inválido.') : delete formErrors.email;
				break;
			case 'first_name':
				validate = /^([a-zA-ZñÑáéíóúÁÉÍÓÚüÜ ]{3,})$/.test(value);
				!validate
					? (formErrors.first_name = 'Nombres inválidos.')
					: delete formErrors.first_name;
				break;
			case 'last_name':
				validate = /^([a-zA-ZñÑáéíóúÁÉÍÓÚüÜ ]{3,})$/.test(value);
				!validate
					? (formErrors.last_name = 'Apellidos inválidos.')
					: delete formErrors.last_name;
				break;
			case 'phone_one':
				validate = /^([0-9()+ -]{10,})$/.test(value);
				!validate
					? (formErrors.phone_one =
							'Teléfono inválido. Ejemplo: +1 (809) 547 7007 ')
					: delete formErrors.phone_one;
				break;
			case 'message':
				validate = /^([a-zA-Z0-9ñÑáéíóúÁÉÍÓÚüÜ (){}[,#+*`~.\]-]{15,})/.test(
					value
				);
				!validate
					? (formErrors.message = 'Debe ingresar un mensaje válido.')
					: delete formErrors.message;
				break;
			default:
				break;
		}
		setFormErrors(form);
	};

	const validatePhone = (value) => {
		setContact({ ...contact, phone_one: value });
		validateField('phone_one', value);
	};

	const resetData = () => setContact(defaultValues());

	const handleSubmit = (event) => {
		event.preventDefault();
		getTokenReacaptcha(async (recaptcha) => {
			setShowLoadding(true);
			await Common.leads({ ...contact, recaptcha })
				.then(async (res) => {
					setOpenAlert(true);
					setMessageAlert('Enviado exitosamente.');
					resetData();

					const event = {
						dataLayer: {
							event: 'evento-formulario-contacto'
						}
					};
					TagManager.dataLayer(event);
				})
				.catch((e) => {
					setOpenAlert(true);
					setMessageAlert(
						e.response && e.response.data
							? e.response.data.error.message
							: 'Hubo un error al ingresar, intente nuevamente.'
					);
				});

			setShowLoadding(false);
		});
	};

	const disabled = useMemo(
		() =>
			!contact.first_name ||
			!contact.last_name ||
			!contact.email ||
			contact.phone_one.length < 2 ||
			!contact.message ||
			Object.keys(formErrors).length > 0,
		[contact, formErrors]
	);

	return (
		<>
			{showLoadding === true && <SpinnerV />}
			<style global jsx>
				{`
					@media only screen and (min-width: 600px) and (max-width: 959px) {
						.contact-field-phone.telInputNoLabel,
						.contact-field-phone.telInputNoLabelError {
							width: 100% !important;
						}
					}
				`}
			</style>
			<form
				className="w-full md:w-3/5 flex flex-col px-4"
				onSubmit={handleSubmit}
			>
				<div className="text-sm text-pink-500 ml-2">
				Déjanos tus datos de contacto y cualquier pregunta que tengas. Te responderemos a la brevedad posible. Por favor, ten en cuenta que a través de esta vía no será posible dar una orientación médica.
				</div>
				<div className="flex flex-wrap">
					<TextInput
						name="first_name"
						placeholder="Nombre"
						helperText={formErrors.first_name}
						errors={formErrors.first_name}
						value={contact.first_name}
						addClass="wInputTwo mx-2"
						onChange={handleInput}
						required={true}
						disabled={showLoadding}
					/>

					<TextInput
						name="last_name"
						placeholder="Apellido"
						helperText={formErrors.last_name}
						errors={formErrors.last_name}
						value={contact.last_name}
						addClass="wInputTwo mx-2"
						onChange={handleInput}
						required={true}
						disabled={showLoadding}
					/>
				</div>
				<div className="flex flex-wrap">
					<TextInput
						name="email"
						placeholder="Correo electrónico"
						helperText={formErrors.email}
						errors={formErrors.email}
						value={contact.email}
						addClass="wInputTwo mx-2"
						onChange={handleInput}
						required={true}
						disabled={showLoadding}
					/>
					<div className="flex wInputTwo mx-2">
						<ReactTelInput
							required={true}
							error={true}
							helperText={formErrors.phone_one && formErrors.phone_one}
							onChange={(value) => validatePhone(value)}
							value={contact.phone_one}
							defaultCountry="do"
							flagsImagePath={Flags}
							className={`contact-field-phone m-0 ${
								!contact.phone_one
									? 'telInputNoLabel'
									: formErrors.phone_one
									? 'telInputNoLabelError'
									: 'telInputNoLabel'
							}`}
						/>
					</div>
				</div>
				<div className="flex">
					<TextInput
						multiline={true}
						rows={4}
						name="message"
						placeholder="Mensaje"
						helperText={formErrors.message}
						errors={formErrors.message}
						value={contact.message}
						addClass="wInputFull mx-2"
						onChange={handleInput}
						required={true}
						disabled={showLoadding}
					/>
				</div>

				<div className="w-full flex justify-center">
					<button className="primary-button my-14" disabled={disabled}>
						Enviar
					</button>
				</div>
			</form>
			<SnackBar
				openAlert={openAlert}
				messageAlert={messageAlert}
				handleClose={handleClose}
			/>
		</>
	);
};

const defaultValues = () => ({
	first_name: '',
	last_name: '',
	phone_one: '',
	email: '',
	message: '',
	origin: 'Organic',
	country: '',
	ip: '',
	ip_data: {},
	recaptcha: ''
});

const mapDispatchToProps = (dispatch) => ({
	actions: bindActionCreators(actions, dispatch)
});

export default connect(null, mapDispatchToProps)(Form);
